// src/utils/endpointLabels.ts

const LABELS: Record<string, string> = {
  '/Auth/login': 'Sign in',
  '/Auth/logout': 'Sign out',
  '/Auth/refresh': 'Refresh session',
  '/Booking': 'Bookings',
  '/Booking/grouped': 'Bookings (grouped)',
  '/Booking/deleted': 'Deleted bookings',
  '/Booking/send-booking-form': 'Send booking form',
  '/Booking/booking-form-log': 'Booking form email log',
  '/Client': 'Clients',
  '/Client/deleted': 'Deleted clients',
  '/Pets': 'Pets',
  '/Pets/deleted': 'Deleted pets',
  '/Kennel': 'Kennels',
  '/Vet': 'Vets',
  '/Payment': 'Payments',
  '/Invoice': 'Invoices',
  '/Invoice/email-log': 'Invoice email log',
  '/User': 'Users',
  '/PerformanceMetrics': 'Performance data',
  '/PerformanceMetrics/stats': 'Performance stats',
  '/ReferenceData/PetTypes': 'Pet types',
  '/ReferenceData/PetBreeds': 'Pet breeds',
  '/ReferenceData/PetSizes': 'Pet sizes',
  '/ReferenceData/PetColours': 'Pet colours',
  '/ReferenceData/PetReferenceUsage': 'Pet reference usage',
  '/ReferenceData/KennelSizes': 'Kennel sizes',
  '/ReferenceData/KennelSides': 'Kennel sides',
  '/ActivityLog': 'Activity log',
  '/ActivityLogRetention': 'Activity log retention',
  '/ErrorLog': 'Error log',
  '/Health': 'Health check',
  '/Seed': 'Seed data',
  '/quotes': 'Quotes',
  '/quotes/quick': 'Create quote (quick)',
  '/quotes/detailed': 'Create quote (detailed)',
  '/quotes/convert': 'Convert quote',
  '/quotes/pdf': 'Download quote PDF',
  '/quotes/email': 'Email quote',
  '/quotes/email-log': 'Quote email log',
};

export function stripQueryString(endpoint: string): string {
  const idx = endpoint.indexOf('?');
  return idx === -1 ? endpoint : endpoint.substring(0, idx);
}

export function getFriendlyEndpoint(endpoint: string): string {
  if (!endpoint) return 'Unknown';
  const path = stripQueryString(endpoint);

  if (LABELS[path]) return LABELS[path];

  const noId = path.replace(/\/\d+$/, '');
  if (LABELS[noId]) return LABELS[noId];

  const noMidId = path.replace(/\/\d+\//, '/');
  if (LABELS[noMidId]) return LABELS[noMidId];

  return path;
}
